import { setupListeners } from '@reduxjs/toolkit/query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter } from 'react-router';
import { App } from '@/app/App';
import { createAppRoutes } from '@/app/routes';
import { setupStore } from '@/app/store';
import { restoreSession, syncSessionAcrossTabs } from '@/features/auth';
import { loadPortalState } from '@/features/portal';
import '@/styles/css/main.css';
import '@/styles/explorer.css';
import '@/styles/records.css';
import '@/styles/help.css';
import '@/styles/guid.css';
import '@/styles/help-bulb.css';
import '@/styles/table-sort.css';
import '@/styles/table-fixed.css';
import '@/styles/reports.css';

const store = setupStore(loadPortalState());
store.dispatch(restoreSession());
store.dispatch(syncSessionAcrossTabs());
// Enables RTK Query refetchOnFocus/refetchOnReconnect behaviours.
setupListeners(store.dispatch);

const router = createBrowserRouter(createAppRoutes());

const container = document.getElementById('root');
if (!container) throw new Error('Root element #root not found');

createRoot(container).render(
  <StrictMode>
    <App store={store} router={router} />
  </StrictMode>,
);
